import { Component, OnInit, HostListener } from '@angular/core';
import {LogService} from "../../services/log.service";
import {UrlBuilderFactory} from "../../shared/factories/url-builder.factory";
import {LocalStorage} from "../../shared/wrappers/LocalStorage";
import {CommonHelper} from "../../shared/helpers/CommonHelper";
import {LogFiltersFactory} from "../../shared/factories/logs/filters.factory";
import * as _ from "lodash";

@Component({
  selector: 'app-log',
  templateUrl: './log.component.html',
  styleUrls: ['./log.component.css']
})
export class LogComponent implements OnInit {
    filters = {
        url: null,
        verb: { list: [], options: null, selected: [] },
        user: { list: [], options: null, selected: [] },
        timestamp: { list: [], options: null, selected: [] },
        limit: { list: [5, 10, 50, 100], selected: 10 },
        date: { selected: null },
        skip: 0
    };

    logs: any[];
    totalItems: number = 0;
    currentPage: number = 1;
    loading;
    options:any;


  constructor(private LogService: LogService,
              private logFiltersFactory: LogFiltersFactory,
              private queryStringFactory: UrlBuilderFactory,
              private localStorage: LocalStorage,
              private commonHelper:CommonHelper) { }

  async ngOnInit() {
      this.loading = true;
      this.filters = await this.logFiltersFactory.build(this.filters);
      await this.search();
      this.loading = false;
  }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {

        if (event.keyCode === 13) {
            this.search(1);
        }

    }

    saveFilters(){};

    async search(page?: number) {
        this.loading = true;
        this.currentPage = 1;
        this.options = this.commonHelper.getDatePickerOptions();
        const response = await this.LogService.get(this.queryStringFactory.build(this.loadFilters(page)));
        this.logs = _.get(response, 'logs', []);
        this.totalItems = response.totalItems[0]?response.totalItems[0].totalItems:0;
        this.loading = false;
    }

    loadFilters(page?) {
        this.currentPage = page ? page : (this.currentPage ? this.currentPage : 1);

        let filters = {};

        _.forOwn(this.filters, (value, key) => {
            const selected = _.get(value, 'selected', value);
            if (selected == 'undefined' || selected == null) return;

            filters[key] = selected;
            filters[key] = _.isArray(filters[key]) ? filters[key].map(item => _.get(item, 'id')) : filters[key];
        });

        return {
            ...filters,
            limit: this.filters.limit.selected,
            skip: (this.currentPage - 1) * this.filters.limit.selected
        };
    }

}



// WEBPACK FOOTER //
// ./src/app/views/log/log.component.ts